import { useState, useEffect } from 'react';
import { getStoredAuth, setAuth, clearAuth, validateCredentials, getAuthErrorMessage } from '../utils/auth';

interface UseAuthReturn {
  isAuthenticated: boolean;
  login: (username: string, password: string) => string | null;
  logout: () => void;
}

export const useAuth = (): UseAuthReturn => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const authState = getStoredAuth();
    setIsAuthenticated(authState.isAuthenticated);
  }, []);

  const login = (username: string, password: string): string | null => {
    const configError = getAuthErrorMessage();
    if (configError) {
      return configError;
    }

    if (validateCredentials(username, password)) {
      setIsAuthenticated(true);
      setAuth();
      return null;
    } else {
      return 'auth.error';
    }
  };

  const logout = (): void => {
    setIsAuthenticated(false);
    clearAuth();
  };

  return {
    isAuthenticated,
    login,
    logout
  };
};